/** @jsx jsx */
import { graphql, useStaticQuery } from 'gatsby';
import { useFavorites } from '@bottlebooks/gatsby-plugin-bookmarks/src';

// This is shadowed by the CMS
export default function useMenuQuery({ locale }) {
  const {
    event,
    site: { siteMetadata },
  } = useStaticQuery(query);
  const enhance = useMenuEnhancer();
  const localeOverride = siteMetadata.locales?.find(
    (metadata) => metadata?.locale === locale
  );
  if (localeOverride?.menuItems) return localeOverride.menuItems.map(enhance);
  const menuItems = siteMetadata.menuItems?.filter(
    (item) => item.name || item.url
  );
  if (menuItems?.length) return menuItems.map(enhance);
  return event?.menuItems?.map(enhance);
}

/**
 * Not sure if we need this anymore. Favorites is now a permanent item
 * in the header.
 * Keeping because it is an interesting pattern.
 * @returns
 */
function useMenuEnhancer() {
  const { favorites } = useFavorites();
  return function enhanceMenuItem(item) {
    if (item.type === 'tastingList')
      return { ...item, counter: favorites?.length };
    return item;
  };
}

const query = graphql`
  {
    site {
      siteMetadata {
        menuItems {
          name
          type
          url
        }
        locales {
          locale
          menuItems {
            name
            type
            url
          }
        }
      }
    }
    event {
      locale
      menuItems {
        name
        type
        url
      }
    }
  }
`;
